import { Statistic } from 'antd';
import type { ComponentProps, ReactNode } from 'react';

export interface StatsRowItem {
  label: ReactNode;
  value: ComponentProps<typeof Statistic>['value'];
}

export function StatsRow({ items }: { items: StatsRowItem[] }) {
  return (
    <div style={{ display: 'grid', gap: 8, gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
      {items.map(item => (
        <Statistic key={String(item.label)} title={<StatsTitle>{item.label}</StatsTitle>} value={item.value} />
      ))}
    </div>
  );
}

function StatsTitle({ children }: { children: ReactNode }) {
  return <span style={{ display: 'block', minHeight: 38, overflowWrap: 'anywhere' }}>{children}</span>;
}
